angular.module('main').directive('fileModel', [
	'$parse',
	function($parse) {
		return {
			restrict: 'A',
			link(scope, element, attrs) {
				const model = $parse(attrs.fileModel);
				const modelSetter = model.assign;
				element.bind('change', () => {
					scope.file_name = element[0].files[0].name;
					console.log(element[0].files[0].name);
					scope.$apply(() => {
						modelSetter(scope, element[0].files[0]);
					});
				});
			}
		};
	}
]);



// WEBPACK FOOTER //
// ./web/js/components/fileModel.js